import { useTranslation } from 'react-i18next';

import { useViewer } from '@/entities/viewer';
import { ProfileForm } from '@/features/account';
import { SettingsShell } from '@/features/settings-shell';
import { LoadingState } from '@/shared/ui';

import styles from './AccountPage.module.css';

/** Settings -> Profile: who you are, your language and time settings. */
export function AccountPage() {
  const { t } = useTranslation();
  const viewer = useViewer();
  if (viewer.status !== 'authenticated') return <LoadingState />;
  return (
    <SettingsShell>
      <div className={styles.page}>
        <h1 className={styles.title}>{t('settings.profile')}</h1>
        <section className={styles.card} aria-labelledby="profile-title">
          <h2 id="profile-title" className={styles.sectionTitle}>
            {t('account.profile')}
          </h2>
          <ProfileForm user={viewer.user} />
        </section>
      </div>
    </SettingsShell>
  );
}
